<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vrxCn9/CoverDesign.jpg?1685327484496" alt="This image is the cover for the book Finding Family, Dreamspun Desires"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Finding Family, Dreamspun Desires
      </h1>
      <p class="bookDescription body article font2">
        <p>When you find your family, you’ll do anything to keep it.</p> <p>When Charles Macquarrie inherits a fortune and an international clothing company, he also inherits three young cousins he desperately needs help raising. By a stroke of luck, he discovers and hires Jonathan Lamb, who spent his life in a children’s home due to chronic illness, to be his nanny.</p> <p>If Jon thought a budding romance with his wealthy boss complicated his life, he has no idea of the hardships awaiting him when he’s charged with embezzlement and kidnapping. But even when threatened by accounting discrepancies and mob connections, Jon and Charles won’t let go of the family they’ve built together without a fight.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Connie Bailey
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?835fb116